import styled from "@emotion/styled";
import React, { FC } from "react";
import { ToastContainer } from "react-toastify";

const StyledToastContainer = styled(ToastContainer)`
  width: auto;
  min-width: 320px;
  max-width: 40%;
  min-height: 200px;

  @media (max-width: 768px) {
    top: 0;
    right: 0;
    bottom: auto;
    left: auto;
    transform: none;
    min-width: 100%;
    max-width: 100%;
  }
`;

const FlowioastContainer: FC = () => (
  <StyledToastContainer
    position="top-right"
    autoClose={false}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    draggable
    pauseOnHover
  />
);

export default FlowioastContainer;
